import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Truck, MapPin, Package } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import apiClient from '../../utils/api';

export const TransporterDashboard: React.FC = () => {
  const { user } = useAuth();
  const [shipments, setShipments] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const res = await apiClient.listShipments({ transporterId: user?.id }, 20, 0);
      const d = res.data.data;
      setShipments(d?.shipments ?? d?.rows ?? (Array.isArray(d) ? d : []));
    } catch {} finally { setLoading(false); }
  }, [user?.id]);

  useEffect(() => { load(); }, [load]);

  const active = shipments.filter(s => ['DEPARTED', 'IN_TRANSIT'].includes(s.status));
  const delivered = shipments.filter(s => s.status === 'DELIVERED');

  return (
    <>
      <div className="page-header">
        <h1 className="page-title">Welcome, {user?.firstName}!</h1>
      </div>

      {loading ? <div className="loading-spinner">Loading...</div> : (
        <>
          <div className="stats-grid">
            {[
              { label: 'Assigned Shipments', value: shipments.length, color: '#3b82f6', icon: <Package size={20} /> },
              { label: 'Active Deliveries', value: active.length, color: '#f59e0b', icon: <Truck size={20} /> },
              { label: 'Delivered', value: delivered.length, color: '#22c55e', icon: <MapPin size={20} /> },
            ].map(s => (
              <div key={s.label} className="stat-card" style={{ borderLeft: `4px solid ${s.color}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    <div className="stat-label">{s.label}</div>
                    <div className="stat-value" style={{ color: s.color }}>{s.value}</div>
                  </div>
                  <div style={{ color: s.color, opacity: 0.6 }}>{s.icon}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="card">
            <div className="page-header" style={{ marginBottom: 16 }}>
              <h2 style={{ fontSize: 15, fontWeight: 600 }}>My Assigned Shipments</h2>
            </div>
            {shipments.length === 0 ? (
              <div className="empty-state"><h3>No shipments assigned yet</h3></div>
            ) : (
              <div className="table-wrapper">
                <table>
                  <thead>
                    <tr><th>Tracking #</th><th>Receiver</th><th>Destination</th><th>Status</th><th></th></tr>
                  </thead>
                  <tbody>
                    {shipments.map((s: any) => (
                      <tr key={s.id}>
                        <td><code style={{ fontSize: 11 }}>{s.trackingNumber}</code></td>
                        <td>{s.receiverName}</td>
                        <td>{s.receiverCity || s.receiverAddress}</td>
                        <td><span className={`badge badge-${s.status?.toLowerCase().replace(/_/g, '-')}`}>{s.status}</span></td>
                        <td>
                          <Link to={`/transporter/shipments/${s.id}`} className="btn btn-ghost" style={{ padding: '3px 8px', fontSize: 12 }}>
                            View
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};
